import type { ProveedorAsignado } from "@/lib/types";
import { KV } from "./KV";

/** Contenido del accordion "Proveedor asignado" en el tab Resumen. */
export function ProveedorContent({ prov }: { prov: ProveedorAsignado }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <KV label="Número" value={`#${prov.numeroProveedor}`} mono />
      <KV label="RFC" value={prov.rfc} mono />
      <KV label="Razón social" value={prov.razonSocial} />
    </div>
  );
}
